import useTranslate from "../../../hooks/use-translate";
import { ProductVariantType } from "../../../types/airgraft";
import { ProductDetailsPageData_datoCmsProduct_variants_modules as ProductVariantContentModules } from "../../../templates/ProductDetailsPage/__generated__/ProductDetailsPageData";

/**
 * Add dynamic content modules for oil products using Oil variant details information
 */
export const generateOilDynamicContentModules = (
  productVariant: ProductVariantType
): ProductVariantContentModules[] => {
  const t = useTranslate();
  const modules = [];
  const { variantDetail } = productVariant;

  // Aroma & Flavor Chart
  if (variantDetail.aromasDetails) {
    modules.push({
      model: {
        apiKey: "generated_c_module_pv_oil_aromasDetails"
      },
      title: t("pdp.aromasDetails.title"),
      chartData: variantDetail.aromasDetails
    });
  }

  // Effects Chart
  if (variantDetail.effectsDetails) {
    modules.push({
      model: {
        apiKey: "generated_c_module_pv_oil_effectsDetails"
      },
      title: t("pdp.effectsDetails.title"),
      chartData: variantDetail.effectsDetails
    });
  }

  // Oil profile
  const oilProfileModule = {
    model: {
      apiKey: "c_module_pv_tech_spec"
    },
    title: t("pdp.oilProfile.title"),
    description: productVariant.descriptionNode.childMarkdownRemark.html,
    specs: []
  };
  if (variantDetail.plantSpeciesDominance) {
    oilProfileModule.specs.push({
      title: t("pdp.oilProfile.dominance"),
      value: variantDetail.plantSpeciesDominance
    });
  }
  if (variantDetail.effects.length > 0) {
    oilProfileModule.specs.push({
      title: t("pdp.oilProfile.effect"),
      value: variantDetail.effects.map(e => e.name).join(", ")
    });
  }
  if (variantDetail.aromas.length > 0) {
    oilProfileModule.specs.push({
      title: t("pdp.oilProfile.aromas"),
      value: variantDetail.aromas.map(a => a.title).join(", ")
    });
  }
  if (
    variantDetail.intensity !== undefined ||
    variantDetail.intensity !== null
  ) {
    oilProfileModule.specs.push({
      title: t("pdp.oilProfile.intensity"),
      value: getOilIntensityLabel(variantDetail.intensity)
    });
  }

  if (oilProfileModule.specs.length > 0) {
    modules.push(oilProfileModule);
  }

  // Oil contents
  if (
    variantDetail.coaReport &&
    variantDetail.coaReport.ingredients &&
    variantDetail.coaReport.ingredients.length > 0
  ) {
    modules.push({
      model: {
        apiKey: "generated_c_module_pv_oil_coaReport_ingredients"
      },
      title: t("pdp.coaReportIngredients.title"),
      coaReport: variantDetail.coaReport
    });
  }

  // Brand profile
  if (productVariant.brand) {
    modules.push({
      model: {
        apiKey: "generated_c_module_pv_brand_profile"
      },
      title: t("pdp.brandProfile.title"),
      brand: productVariant.brand
    });
  }

  // Certificate of Analysis
  if (variantDetail.coaReport) {
    modules.push({
      model: {
        apiKey: "generated_c_module_pv_oil_coaReport"
      },
      title: t("pdp.coaReport.title"),
      coaReport: variantDetail.coaReport
    });
  }

  return modules;
};

export const getOilIntensityLabel = (intensity: number) => {
  const t = useTranslate();
  switch (intensity) {
    case 3: {
      return t("pdp.oilProfile.intensity.potentPsychoactive");
    }
    case 2: {
      return t("pdp.oilProfile.intensity.potentPsychoactive");
    }
    case 1: {
      return t("pdp.oilProfile.intensity.mildPsychoactive");
    }
    case 0:
      {
        return t("pdp.oilProfile.intensity.nonPsychoactive");
      }
      return "";
  }
};
